<template>
  <div>
    <!--    <b-modal v-model="removalAcceptance" :cancel-title="$t('general.no')" :ok-title="$t('general.yes')"-->
    <!--             centered-->
    <!--             size="sm" @cancel="removalAcceptance = false" @ok="deletionConfirmed">-->
    <!--      <p>{{ $t('toastification.areYouSureOfDeletion', {item: itemToDelete ? itemToDelete.title : ''}) }}</p>-->
    <!--    </b-modal>-->
    <b-modal v-model="groupRemovalAcceptance" :cancel-title="$t('general.no')" :ok-title="$t('general.yes')"
             centered
             size="sm" @cancel="removalAcceptance = false" @ok="groupDeletionConfirmed">
      <p>{{ $t('toastification.areYouSureOfDeletion', {item: itemToDelete ? itemToDelete.title : ''}) }}</p>
    </b-modal>
    <!--    <b-modal v-model="enableGrouping" centered hide-footer size="xl">-->
    <!--      <permission-group-modal :permissions="permissions" :formattedPermissions="formattedPermissions" :v="$v"-->
    <!--                              @groupCreated="groupCreated"></permission-group-modal>-->
    <!--    </b-modal>-->
    <!--    <div class="custom-search d-flex justify-content-start">-->
    <!--      <b-form-group>-->
    <!--        <div class="d-flex align-items-center">-->
    <!--          <label class="mr-1">{{ $t('general.search') }}</label>-->
    <!--          <b-form-input-->
    <!--              v-model="searchTerm"-->
    <!--              :placeholder=" $t('general.search')"-->
    <!--              class="d-inline-block"-->
    <!--              type="text"-->
    <!--              @input="searchParityType"-->
    <!--          />-->
    <!--        </div>-->
    <!--      </b-form-group>-->
    <!--    </div>-->


    <div class="white-section mt-2">
      <b-row class="d-flex justify-content-end mb-2">
        <!--        <b-col class="d-flex justify-content-end" cols="1">-->
        <!--          <b-button-->
        <!--              size="sm"-->
        <!--              variant="info"-->
        <!--              @click="enableGrouping = true"-->

        <!--          >{{ $t("permissions.createPermissionsGroup") }}-->
        <!--          </b-button>-->
        <!--        </b-col>-->
        <b-col class="d-flex justify-content-end" cols="1">
          <b-button

              size="sm"
              to="/permissionGroups/add"
              variant="primary"
          >{{ $t('general.add') }}
          </b-button>
        </b-col>
        <!--        <router-link tag="button" to="/permissions/add" class="btn btn-success">{{ $t('general.add') }}</router-link>-->
      </b-row>
      <div class="box-has-title">
        <b-col md="12">
          <hr :data-content="$t('permissions.permissionGroups')" class="hr-text"/>
        </b-col>
        <vue-good-table
            v-if="permissionGroups"
            :columns="columns"
            :rows="permissionGroups"
            class="permissiongroup-table"
                    >
          <template slot="table-column" slot-scope="props">
            <span v-if="props.column.label === 'action'" class="text-nowrap">

              {{ $t("general.action") }}
            </span>
            <span v-else>
              {{ $t(`permissions.${props.column.label}`) }}
            </span>
          </template>

          <!-- Slot: Table Row -->
          <template slot="table-row" slot-scope="props">
            <!-- Column: Name -->
            <!--          <span v-if="props.column.field === 'name'" class="text-nowrap">-->
            <!--              <span>{{ props.row.firstName }} {{ props.row.lastName }}</span>-->
            <!--            </span>-->
            <span v-if="props.column.field === 'permissionsList'">
            <span v-for="(p, index) in props.row.permissions" :key="p">{{
                permissions.find((permission => {
                  return permission._id === p
                })) ? permissions.find((permission => {
                  return permission._id === p
                })).title + ' / ' : ''
              }}</span>

          </span>
            <!-- Column: Action -->
            <span v-if="props.column.field === 'action'">
            <b-row class=" permissiongroup-button d-flex align-items-center m-auto">
                   <b-button size="sm" class="bg-danger" style="border:none ; width:52px ; height:26px" @click="deleteAGroup(props.row)">
                    <!-- <feather-icon icon="TrashIcon"/> -->
                        <span @click="deleteAGroup(props.row)">{{ $t("general.delete") }}</span>
                    </b-button>
                 <b-button size="sm" class="bg-info" style="border:none;" @click="editAGroup(props.row)">
                    <span>{{ $t("general.detailsAndEdit") }}</span>
                  </b-button>
              </b-row>
            </span>
            <!-- Column: Common -->
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>

        </vue-good-table>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import {
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BAlert,
  BCol,
  BRow,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BButton
} from 'bootstrap-vue'
import {VueGoodTable} from 'vue-good-table'
import {VSelectTree, VTree} from 'vue-tree-halower'
import PermissionGroupModal from "@/components/permissions/PermissionGroupModal";


export default {
  components: {
    PermissionGroupModal,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BAlert,
    BDropdown,
    BDropdownItem,
    BFormCheckbox,
    BButton,
    BCol,
    BRow,
    VSelectTree,
    VTree,
    VueGoodTable
  },
  data() {
    return {
      // selectedPermissions: [],
      formattedPermissions: [],
      treeData: null,
      searchTerm: "",
      // enableGrouping: false,
      removalAcceptance: false,
      groupRemovalAcceptance: false,
      itemToDelete: null,
      columns: [
        {
          label: "groupTitle",
          field: "title",
        },
        {
          label: "permissions",
          field: "permissionsList",
        },
        {
          label: "action",
          field: "action",
          sortable: false
        }
      ],
    }
  },
  methods: {
    tpl(...args) {
      const {0: node, 2: parent, 3: index} = args
      let titleClass = node.selected ? 'node-title node-selected' : 'node-title'
      if (node.searched) titleClass += ' node-searched'
      return <span>

        <span class={titleClass} domPropsInnerHTML={node.title} onClick={() => {
          this.$refs.tree.nodeSelected(node)
        }}></span>
          <feather-icon icon="TrashIcon" className="mr-50" onClick={() => this.deleteANode(node, parent, index)}/>


      </span>
    },

    deleteAGroup(group) {
      // console.log(group)
      this.itemToDelete = group;
      this.groupRemovalAcceptance = true;
    },
    editAGroup(group) {
      this.groupToEdit = group;
      this.$router.push({name: 'editPermissionGroups', params: {groupId: group._id}})
    },

    groupDeletionConfirmed() {
      this.$store.dispatch('permissions/deletePermissionGroup', this.itemToDelete._id).then((res) => {
        

        this.$bvToast.toast(this.$t('toastification.deletionSucceed'), {
          // title: this.$t('toastification.success'),
          variant: 'success',
          solid: true,
        });
        this.permissionGroups = this.permissionGroups.filter((p) => {
          return p._id !== res._id
        });

        this.groupRemovalAcceptance = false;

      })
    },
    // groupCreated() {
    //   this.enableGrouping = false;
    // },
    async asyncLoad(node) {
      this.$set(node, 'loading', true)
      let pro = new Promise(resolve => {
        setTimeout(resolve, 2000, ['async node1', 'async node2'])
      })
      this.$refs.tree1.addNodes(node, await pro)
      this.$set(node, 'loading', false)
    },
    removeItem(index) {
      this.parityTypes.splice(index, 1)
    },
    createFormattedPermission(res) {
      let list = _.cloneDeep(res);
      var map = {}, node, roots = [], i;
      for (i = 0; i < list.length; i += 1) {
        map[list[i]._id] = i; // initialize the map
        list[i].children = []; // initialize the children
      }
      for (i = 0; i < list.length; i += 1) {
        node = list[i];
        if (node.parentId !== null) {
          // if you have dangling branches check that map[node.parentId] exists
          // console.log(node)

          // list[map[node.parentId]].children = [];
          // list[map[node.parentId]].id = list[map[node.parentId]]._id;
          list[map[node.parentId]].children.push(node);
        } else {
          roots.push(node);
        }
      }
      // console.log(roots)
      this.formattedPermissions = roots;
      // console.log(this.formattedPermissions)
    }
  },
  computed: {
    ...mapGetters({
      // permissions: 'permissions/permissions',
      // permissionGroups: 'permissions/permissionGroups',
    }),
    permissions: {
      get() {
        return this.$store.getters['permissions/permissions']
      },
      set(permissions) {
        this.$store.commit('permissions/SET_PERMISSIONS', permissions)
      }
    },
    permissionGroups: {
      get() {
        return this.$store.getters['permissions/permissionGroups']
      },
      set(permissionGroups) {
        this.$store.commit('permissions/SET_PERMISSION_GROUPS', permissionGroups)
      }
    },
    groupToEdit: {
      get() {
        return this.$store.getters['permissions/groupToEdit']
      },
      set(groupToEdit) {
        this.$store.commit('permissions/SET_GROUP_TO_EDIT', groupToEdit)
      }
    },
  },
  created() {
    this.$store.dispatch('permissions/getPermissions').then((res) => {
      this.createFormattedPermission(res);

      // return roots;
    })
    this.$store.dispatch('permissions/getPermissionGroups')
    this.setBreadcrumbs([
      { text: "homePage", translate: true, to: { name: "home" } },
      { text: "permission", translate: true },
      { text: "permissionGroups", to: { name: "permissionGroups" }, translate: true },
    ]);
    this.setCurrentBreadcrumb([
      { text: "permissionGroups", to: { name: "permissionGroups" }, translate: true },
    ]);
  },
}
</script>

<style lang="scss">
.permissions-tree {
  //font-size: 20px;
  .halo-tree li:before {
    //border-right: 2px dashed #999
  }

  .tree-box {
    background-color: white;
  }
}
table th:last-child{
  width:200px !important
}

</style>